import { memo } from 'react';
import { Chip } from '@mui/material';
import {
  getCustomerEnvironmentApplicationSourceBackgroundColor,
  getCustomerEnvironmentApplicationSourceBorderColor,
  getCustomerEnvironmentApplicationSourceColor,
  getCustomerEnvironmentApplicationSourceLabel,
} from 'src/utils/enums/customerEnvironmentApplicationSource';

const ApplicationSourceChip = ({ source, sx }) => {
  if (!source) {
    return null;
  }

  return (
    <Chip
      size="small"
      variant="outlined"
      label={getCustomerEnvironmentApplicationSourceLabel(source)}
      sx={{
        height: 22,
        fontSize: '11px',
        fontWeight: 500,
        textTransform: 'none',
        color: getCustomerEnvironmentApplicationSourceColor(source),
        borderColor: getCustomerEnvironmentApplicationSourceBorderColor(source),
        backgroundColor: getCustomerEnvironmentApplicationSourceBackgroundColor(source),
        ...sx,
      }}
    />
  );
};

export default memo(ApplicationSourceChip);
